import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite} from "gsap";
import {TeslaSoundConfig} from "../../TeslaSoundConfig";
/**
 * Class description
 *
 * Created: 2017-09-25
 * @author jonas
 */
import {TeslaCollectLight} from "./TeslaCollectLight";

export class TeslaLightGroup extends PIXI.Container {
    private _lights:TeslaCollectLight[];

    constructor() {
        super();

        this._lights = [];

        for(let i:number = 0; i < 3; i++) {
            let light = new TeslaCollectLight();
            light.position.set(31 * i, 0);
            this._lights.push(light);
            this.addChild(light)
        }
    }


    public getLightAnimations(turnedOnCount:number, isRestore?:boolean):TimelineLite[] {

        let groupTimeline:TimelineLite[] = [];

        for(let i:number = 0; i < this._lights.length; i++) {
            const tl:TimelineLite = new TimelineLite();
            let light = this._lights[i];
            if(i < turnedOnCount) {
                if(!light.isOn) {
                    tl.add(light.getTurnOnAnimation(isRestore));
                }
            } else {
                tl.add(light.getTurnOffAnimation());
            }

            if(tl.duration() > 0) {
                groupTimeline.push(tl);
            }

        }

        return groupTimeline;
    }

    public getIntro():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < this._lights.length; i++) {
            let light = this._lights[i];
            tl.add([
                light.getIntro(),
                () => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_INTRO_BALL_UP)
            ], 0.13 * i);
            tl.add(() => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_INTRO_BALL_LANDING));
        }
        return tl;
    }

}